import { Text } from '@loadsmart/loadsmart-ui'
import { Layout } from '@loadsmart/miranda-react'

import { type Bid } from '../../domain/Bid'
import { getBidCounterPrice, getBidPrice } from '../../presenters/bidPresenter'
import { Item } from './LoadSummary.styles'

type LoadSummaryBidPriceProps = {
  bid: Bid
}

export function LoadSummaryBidPrice({ bid }: LoadSummaryBidPriceProps) {
  const bidPrice = getBidPrice(bid)
  const bidCounterPrice = getBidCounterPrice(bid)

  return (
    <Item>
      <Layout.Group gap="spacing-30">
        <Layout.Stack gap="spacing-1">
          <Text as="div" variant="caption-bold" color="color-neutral-dark">
            Your bid
          </Text>
          <Text as="div" variant="body-bold">
            {bidPrice}
          </Text>
        </Layout.Stack>
        {bidCounterPrice && (
          <Layout.Stack gap="spacing-1">
            <Text as="div" variant="caption-bold" color="color-neutral-dark">
              Counter offer
            </Text>
            <Text as="div" variant="body-bold">
              {bidCounterPrice}
            </Text>
          </Layout.Stack>
        )}
      </Layout.Group>
    </Item>
  )
}
